import { pdf } from '@react-pdf/renderer'
import type { ReactElement } from 'react'

// Generate temporary url from the PDF blob, create anchor element, and trigger download

export default async function triggerPDFDownload({
  children,
  fileName,
}: {
  children: ReactElement
  fileName: string
}) {
  const blob = await pdf(children).toBlob()
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  URL.revokeObjectURL(url)
}
